import React, { useState } from 'react';
import { getTodayDateInString } from '../../utils/dateLibrary';
import * as Yup from "yup";
import { Badge, Button, Col, Form, InputGroup, Modal, Row } from 'react-bootstrap';
import { ErrorMessage, Formik } from 'formik';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { FaTimes } from 'react-icons/fa';
import { AiOutlineEdit } from "react-icons/ai";
import ReactDatePicker from 'react-datepicker';

export default function EditServiceModal({data, updateService}) {
    const authToken = localStorage.getItem('access_token');

    const validationSchema = Yup.object().shape({
        title: Yup.string().required('Required'),
        description: Yup.string().required('Required'),
        sessionPrice: Yup.number().min(0,'Price must not be less than 0').required('Required'),
        perDayBookings: Yup.number().min(0,'Bookings count must not be less than 0').required('Required'),
        datesAllowed: Yup.array().of(Yup.string()).min(1, "Minimum 1 date required").required("Required"),
        status: Yup.string().required('Required')
    });
    const [show, setShow] = useState(false);
    const [date, setDate] = useState('');
    const [dates, setDates] = useState(data.datesAllowed.split(','));
    const statusOptions = [{label: "Published", value: "published"}, {label: "Expired", value: "expired"}];

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const addItemToList = (setFieldValue) => {
        let tempDates = dates;
        if(date===""){
            
        } else{
            if (tempDates.includes(date)) {
                toast.error('Date already added to the list!');
            } else {
                let day = ("0" + date.getDate()).slice(-2);
                let month = ("0" + (date.getMonth() + 1)).slice(-2);
                let newItem = (day) + "-" + (month) + "-" + date.getFullYear();
                tempDates.push(newItem);
                setDates(tempDates);
                setFieldValue('datesAllowed', tempDates);
                setDate(''); 
            }
        }
    }

    const deleteFromList = (v, setFieldValue) => {
        let tempDates = dates.filter((d) => d !== v);
        setDates(tempDates);
        setFieldValue('datesAllowed', tempDates);
    }

  return (
    <>
            <Button variant="icon" onClick={handleShow}>
                    <AiOutlineEdit size={18} />
                </Button>

            <Modal show={show} size="lg" onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Activity</Modal.Title>
                </Modal.Header>
                <Formik
                    initialValues={{
                        ...data,
                        datesAllowed: data.datesAllowed.split(',')
                    }}
                    validationSchema={validationSchema}
                    onSubmit={(values) => updateService(data.serviceId, values)}
                >
                    {({
                        values,
                        handleChange,
                        handleSubmit,
                        setFieldValue,
                        isSubmitting
                    }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <Row>
                                    <Col md='6'>
                                        <Form.Group className='mb-3'>
                                            <Form.Label>Activity Title</Form.Label>
                                            <Form.Control
                                                type='text'
                                                name='title'
                                                value={values.title}
                                                onChange={handleChange}
                                                placeholder='Type Service Title'
                                                disabled={isSubmitting}
                                            />
                                        </Form.Group>
                                        <ErrorMessage name='title' component='p' className='error-message' />
                                    </Col>
                                    <Col md='6'>
                                        <Form.Group className='mb-3'>
                                            <Form.Label>Status</Form.Label>
                                            <Select
                                                name="status"
                                                className="select-field"
                                                defaultValue={statusOptions.find(opt => opt.value === data.status)}
                                                isSearchable={false}
                                                options={statusOptions}
                                                onChange={(opt) =>
                                                    setFieldValue("status", opt.value)
                                                }
                                                />
                                                <ErrorMessage
                                                name="status"
                                                component="p"
                                                className="error-message"
                                                />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row className="my-3">
                                    <Col md='6'>
                                        <Form.Label>Date</Form.Label>
                                            <ReactDatePicker
                                                selected={date} 
                                                onChange={(val) => setDate(val)} 
                                                dateFormat="dd-MM-yyyy" 
                                                placeholderText="Select a Date"
                                                minDate={new Date()} 
                                                className='form-control'
                                                wrapperClassName='w-100 mb-3'
                                            />
                                        <Button variant="secondary" size="sm" className='mb-3' onClick={() => addItemToList(setFieldValue)}>
                                            Add Date
                                        </Button>
                                        <ErrorMessage name='datesAllowed' component='p' className='error-message' />
                                    </Col>
                                    <Col md='6'>
                                        {
                                            dates.length>0 ?
                                            <h6>Dates Allowed</h6>
                                            :
                                            ''
                                        }
                                        <div className="d-flex flex-wrap align-items-center">
                                            {
                                                dates.map((d, i) => {
                                                    return (
                                                        <div key={i}>
                                                            <Badge className="date-badge me-1">
                                                                <div className="d-flex align-items-center">
                                                                    <span className="me-2">{d}</span>
                                                                    <div
                                                                        style={{ cursor: 'pointer' }}
                                                                        onClick={() => deleteFromList(d, setFieldValue)}
                                                                        className={isSubmitting ?? 'd-none'}
                                                                    >
                                                                        <FaTimes />
                                                                    </div>
                                                                </div>
                                                            </Badge>{' '}
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md='6'>
                                        <Form.Label>Price Per Session</Form.Label>
                                        <InputGroup className='mb-3'>
                                            <InputGroup.Text>£</InputGroup.Text>
                                            <Form.Control
                                                type='number'
                                                name='sessionPrice'
                                                value={values.sessionPrice}
                                                onChange={handleChange}
                                                placeholder='Price'
                                                disabled={isSubmitting}
                                            />
                                        </InputGroup>
                                        <ErrorMessage name='sessionPrice' component='p' className='error-message' />
                                    </Col>
                                    <Col md='6'>
                                        <Form.Label>Allow Per Day Bookings</Form.Label>
                                        <InputGroup className='mb-3'>
                                            <InputGroup.Text>#</InputGroup.Text>
                                            <Form.Control
                                                type='number'
                                                name='perDayBookings'
                                                value={values.perDayBookings}
                                                onChange={handleChange}
                                                placeholder="Bookings allowed per day"
                                                disabled={isSubmitting}
                                            />
                                        </InputGroup>
                                        <ErrorMessage name='perDayBookings' component='p' className='error-message' />
                                    </Col>
                                </Row>

                                <Form.Group className='mb-3'>
                                    <Form.Label>Activity Description</Form.Label>
                                    <Form.Control 
                                        as='textarea' 
                                        rows={3}
                                        name='description'
                                        value={values.description}
                                        onChange={handleChange} 
                                        disabled={isSubmitting}
                                    />
                                </Form.Group>
                                <ErrorMessage name='description' component='p' className='error-message' />
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" size="sm" type='button' onClick={handleClose} disabled={isSubmitting}>
                                    Close
                                </Button>
                                <Button variant="primary" size="sm" type='submit' disabled={isSubmitting}>
                                    Update Activity
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>
        </>
  )
}
